import { customElement, useView } from 'aurelia-templating';
import { widget } from '../widget-decorator';
import { BindingEngine } from 'aurelia-binding';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { PLATFORM } from 'aurelia-framework';
import { AlertService } from '@aurelia-toolkit/alert';
import { property } from '../property-decorator';
import { WidgetPropertyType } from '../widget-property-type';

@customElement('image-widget')
@useView(PLATFORM.moduleName('./image-widget.html'))
@widget('Image', true, true)
export class ImageWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine, public alertService: AlertService) {
    super(element, bindingEngine, customerService);
  }

  @property('Text', 'Image URL', WidgetPropertyType.LargeText)
  imageUrl?: string;
}
